
class BoaProductDescription extends HTMLElement {
  resizeObserver = new ResizeObserver(() => this.updateToggleVisibility());

  onToggle = () => {
    const collapsed = !this.collapsed;

    this.classList.toggle('boa-product-description--collapsed', collapsed);
    this.toggle.setAttribute('aria-expanded', !collapsed);
  };

  connectedCallback() {
    this.text = this.querySelector('[data-boa-description-text]');
    this.toggle = this.querySelector('[data-boa-description-toggle]');

    this.toggle.addEventListener('click', this.onToggle);

    this.resizeObserver.observe(this.text);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  get collapsed() {
    return this.classList.contains('boa-product-description--collapsed');
  }

  updateToggleVisibility() {
    if (!this.collapsed) {
      return;
    }

    this.toggle.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
  }
}

customElements.define('boa-product-description', BoaProductDescription);
